const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASURAMENT_ID,
};

export const initFirebase = async () => {
  await Promise.all([import('firebase/app'), import('firebase/analytics')])
    .then((modules) => modules[0].default)
    .then((firebase) => {
      if (firebase.apps.length === 0 && firebaseConfig) {
        firebase.initializeApp(firebaseConfig);
        firebase.analytics();
      }
    });
};
